export const manageSmashupButtons = (container, canSend, isHidden) => {
    let sendBtn = container.querySelector('#gv-send');
    let previewBtn = container.querySelector('#gv-preview');
    sendBtn?.setAttribute("role", "button");
    sendBtn?.setAttribute("aria-label", "Send");
    sendBtn?.setAttribute("href", "javascript:void(0)");
    sendBtn?.setAttribute("data-cnstrc-btn", "add_to_cart");
    previewBtn?.setAttribute("aria-label", "Preview");
    previewBtn?.setAttribute("role", "button");
    previewBtn?.setAttribute("href", "javascript:void(0)");
    if(isHidden) {
    sendBtn?.classList.add("hidden");
    }
    if (!canSend) {
    sendBtn?.remove();
    }
}

export const useTTSIdleAnimationControl = () => {
    const productExpression = window.agi?.expressions?.ExpressionManager?.expression;
    const button = document.createElement("button");

    button.classList.add("product-detail__animation-toggle");
    button.setAttribute("aria-label", "Pause Idle Animations");
    button.setAttribute("aria-pressed", false);
    button.addEventListener("click", () => {
    productExpression?.stage?.tickEnabled ? pause() : play()
    });

    const pause = () => {
    if (!productExpression) return
    productExpression.stage.tickEnabled = false;
    button.setAttribute("aria-pressed", true);
    }

    const play = () => {
    if (!productExpression) return
    productExpression.stage.tickEnabled = true;
    button.setAttribute("aria-pressed", false);
    }

    return { button, pause, play }

}

export const manageTTSPreviewControls = (container) => {
    // Collect global idex Express instance
    const productExpress = window.agi?.expressions?.Express;

    const proxyMouseup = (event) => {
    if (!["Space", "Enter"].includes(event.code)) return
    event.target?.dispatchEvent(new Event("mouseup"));
    }

    const manageMuteControl = () => {
    const muteButton = container.querySelector("#agi-expression-mute-button");
    muteButton?.setAttribute("aria-label", "Mute");
    muteButton?.setAttribute("aria-pressed", false);
    muteButton?.addEventListener("keyup", proxyMouseup);
    productExpress?.dispatcher?.addEventListener("audioMuted", () => {
        muteButton?.setAttribute("aria-pressed", true);
    })
    productExpress?.dispatcher?.addEventListener("audioUnmuted", () => {
        muteButton?.setAttribute("aria-pressed", false);
    })
    }
    const manageCaptionsControl = () => {
    const captionsButton = container.querySelector("#agi-expression-closed-caption-button");
    captionsButton?.setAttribute("aria-label", "Show Closed Captions");
    captionsButton?.setAttribute("aria-pressed", false);
    captionsButton?.addEventListener("keyup", proxyMouseup);
    productExpress?.dispatcher?.addEventListener("toggleClosedCaptions", () => {
        setTimeout(() => captionsButton?.setAttribute("aria-pressed", productExpress.ccEnabled))
    })
    }

    const manageReplayControl = () => {
    const replayButton = container.querySelector("#agi-expression-replay-button");
    replayButton?.setAttribute("aria-label", "Replay")
    replayButton?.addEventListener("keyup", proxyMouseup);
    }

    manageMuteControl();
    manageCaptionsControl();
    manageReplayControl();
}